import { render, staticRenderFns } from "./myProjectDetails.vue?vue&type=template&id=270ca0e6&scoped=true"
import script from "./myProjectDetails.vue?vue&type=script&lang=js"
export * from "./myProjectDetails.vue?vue&type=script&lang=js"
import style0 from "./myProjectDetails.vue?vue&type=style&index=0&id=270ca0e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270ca0e6",
  null
  
)

export default component.exports